<template>
  <v-progress-linear
    location="top"
    absolute
    :active="visible"
    :indeterminate="visible"
    :height="5"
  ></v-progress-linear>
</template>

<script setup lang="ts">
import { useProgressBar } from '@/composable/progressBar';

const { visible } = useProgressBar();
</script>
